import { render, staticRenderFns } from "./ExpenseReview.vue?vue&type=template&id=ece89e06"
import script from "./ExpenseReview.vue?vue&type=script&lang=js"
export * from "./ExpenseReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports